<div class="internal-panel">

  <!-- Meta row: badge + print + close -->
  <div class="panel-meta-row" *ngIf="request">
    <div class="internal-badge">
      <mat-icon class="lock-icon">lock</mat-icon>
      <span>{{ 'request_v2.workspace.badge.internal' | translate }}</span>
    </div>

    <div class="panel-actions">
      <button type="button" class="action-btn" (click)="print()" [matTooltip]="'common.print' | translate">
        <mat-icon>print</mat-icon>
      </button>
      <button type="button" class="action-btn" (click)="closed.emit()" [matTooltip]="'common.close' | translate">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Bciti tabs — dates row injected as sticky sub-header below tab bar -->
  <app-bciti-tabs>

    <!-- Dates sub-header (not a tab pane, renders inside .tab-content before all panes) -->
    <div class="dates-subheader" *ngIf="request">
      <span class="date-created">{{ formatShortDate(request.createdAt) }}</span>
      <ng-container *ngIf="request.sla">
        <span class="date-arrow">→</span>
        <span class="date-sla"
          [class.sla-past]="slaStatus === 'past'"
          [class.sla-soon]="slaStatus === 'soon'">
          <mat-icon class="sla-icon">calendar_today</mat-icon>
          {{ formatShortDate(request.sla) }}
        </span>
      </ng-container>
    </div>

    <!-- Gestion -->
    <app-bciti-tab [title]="'request_v2.workspace.tabs.management' | translate">
      <div class="sections-list">

        <app-section-block [title]="'request_v2.workspace.section.tasks' | translate">
          <app-request-subtasks
            [request]="request"
            [canEdit]="canEdit"
            (subtasksUpdated)="refreshNeeded.emit()">
          </app-request-subtasks>
        </app-section-block>

        <app-section-block [title]="'request_v2.workspace.section.linked' | translate">
          <app-request-links
            [request]="request"
            [canEdit]="canEdit"
            (requestChanged)="requestChanged.emit($event)"
            (navigateToRequest)="navigateToRequest.emit($event)">
          </app-request-links>
        </app-section-block>

        <app-section-block [title]="'request_v2.info.tags' | translate">
          <div class="tags-body">
            <mat-chip-list #chipList>
              <mat-chip
                *ngFor="let tag of request?.tags || []"
                [removable]="canEdit"
                (removed)="removeTag(tag)">
                {{ tag }}
                <mat-icon matChipRemove *ngIf="canEdit">cancel</mat-icon>
              </mat-chip>
              <input
                *ngIf="canEdit"
                [placeholder]="'request_v2.info.add_tag' | translate"
                [formControl]="tagCtrl"
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
                (matChipInputTokenEnd)="addTag($event)"
                [matAutocomplete]="autoTag"
              />
            </mat-chip-list>
            <mat-autocomplete #autoTag="matAutocomplete" (optionSelected)="selectTag($event)">
              <mat-option *ngFor="let tag of filteredTags" [value]="tag">{{ tag }}</mat-option>
            </mat-autocomplete>
          </div>
        </app-section-block>

        <app-section-block [title]="'request_v2.workspace.section.internal_files' | translate">
          <app-request-internal-files
            [request]="request"
            [canEdit]="canEdit"
            (requestChanged)="requestChanged.emit($event)">
          </app-request-internal-files>
        </app-section-block>
      </div>
    </app-bciti-tab>

    <!-- Collaboration -->
    <app-bciti-tab [title]="'request_v2.workspace.tabs.collaboration' | translate">
      <div class="sections-list">

        <!-- Description interne -->
        <app-section-block [title]="'request_v2.workspace.section.internal_description' | translate">
          <div class="internal-desc-body">
            <!-- View mode -->
            <div class="internal-desc-display"
                 *ngIf="!editingDescription"
                 [class.is-empty]="!request?.internalDescription"
                 (click)="canEdit && startEditDescription()">
              <span class="internal-desc-text" *ngIf="request?.internalDescription">{{ request.internalDescription }}</span>
              <span class="internal-desc-placeholder" *ngIf="!request?.internalDescription">
                {{ 'request_v2.workspace.internal_description_placeholder' | translate }}
              </span>
              <mat-icon *ngIf="canEdit" class="desc-edit-icon">edit</mat-icon>
            </div>
            <!-- Edit mode -->
            <div class="internal-desc-edit" *ngIf="editingDescription">
              <textarea #descTextarea
                        class="internal-desc-textarea"
                        [formControl]="descriptionCtrl"
                        [placeholder]="'request_v2.workspace.internal_description_placeholder' | translate"
                        rows="5"
                        (keydown.escape)="cancelEditDescription()"></textarea>
              <div class="desc-edit-actions">
                <button class="desc-icon-btn desc-cancel-btn" type="button" (click)="cancelEditDescription()" [disabled]="savingDescription">
                  <mat-icon>close</mat-icon>
                </button>
                <button class="desc-icon-btn desc-save-btn" type="button" (click)="saveDescription()" [disabled]="savingDescription">
                  <mat-icon>check</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </app-section-block>

        <app-section-block [title]="'request_v2.workspace.section.notes' | translate">
          <app-request-internal-note
            [request]="request"
            [canEdit]="canEdit"
            (requestChanged)="requestChanged.emit($event)">
          </app-request-internal-note>
        </app-section-block>
      </div>
    </app-bciti-tab>

    <!-- Historique -->
    <app-bciti-tab [title]="'request_v2.workspace.tabs.history' | translate">
      <div class="sections-list">
        <app-section-block [title]="'request_v2.workspace.section.history' | translate">
          <app-request-history [request]="request"></app-request-history>
        </app-section-block>
      </div>
    </app-bciti-tab>

  </app-bciti-tabs>

</div>
